import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import "./index.css";
import App from "./App";

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import "video-react/dist/video-react.css";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,

  document.getElementById("root")
);
